module.exports = __webpack_public_path__ + "img/journal-check.cab6847a.svg";